import { useState } from 'react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconArrowsSort } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { MRT_ToggleGlobalFilterButton, MRT_ToggleFiltersButton, MRT_ShowHideColumnsButton, MRT_ToggleDensePaddingButton, MRT_ToggleFullScreenButton, type MRT_TableInstance } from 'mantine-react-table';

export function TableSortToggle() {
  const [visible,setVisible]=useState(false);
  const {t}=useTranslation();
  const label=t(visible?'common.hideSortControls':'common.showSortControls');
  return <Tooltip label={label} withinPortal><ActionIcon aria-label={label} aria-pressed={visible} variant={visible?'filled':'light'} onClick={event=>{
    const next=!visible;
    event.currentTarget.closest('.mantine-Paper-root')?.classList.toggle('app-show-sort-controls',next);
    setVisible(next);
  }}><IconArrowsSort size={20}/></ActionIcon></Tooltip>;
}

export function TableInternalControls<T extends Record<string,unknown>>({table}:{table:MRT_TableInstance<T>}) {
  const o=table.options;
  return <div className="app-table-controls">
    {o.enableFilters && o.enableGlobalFilter && !o.initialState?.showGlobalFilter && <MRT_ToggleGlobalFilterButton table={table}/>}
    {o.enableFilters && o.enableColumnFilters && o.columnFilterDisplayMode!=='popover' && <MRT_ToggleFiltersButton table={table}/>}
    <TableSortToggle/>
    {(o.enableHiding || o.enableColumnOrdering || o.enablePinning) && <MRT_ShowHideColumnsButton table={table}/>}
    {o.enableDensityToggle && <MRT_ToggleDensePaddingButton table={table}/>}
    {o.enableFullScreenToggle && <MRT_ToggleFullScreenButton table={table}/>}
  </div>;
}
